var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1065_333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 14C1 6.82028 6.82028 1 14 1M1 14C1 21.1797 6.82028 27 14 27M1 14H27M14 1C21.1797 1 27 6.82028 27 14M14 1C10.3953 1 7.47307 6.82023 7.47307 14C7.47307 21.1797 10.3953 27 14 27M14 1C17.6047 1 20.527 6.82023 20.527 14C20.527 21.1797 17.6047 27 14 27M14 1V27M27 14C27 21.1797 21.1797 27 14 27M4.09598 22.4213C6.48048 21.0146 10.0327 20.1224 14 20.1224C17.9673 20.1224 21.5195 21.0146 23.904 22.4213M23.9038 5.57887C21.5193 6.98535 17.9672 7.87755 14 7.87755C10.0329 7.87755 6.48086 6.98535 4.09636 5.57887",
    stroke: "url(#paint0_linear_1065_333)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1065_333",
    x1: 1.46516,
    y1: -1.92345,
    x2: 31.5298,
    y2: 26.2677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE56B0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1065_333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/websiteIcon.707d2b750b3cd1dc2c64b6d1ca66ab78.svg";
export { ForwardRef as ReactComponent };